export enum UIPageEnum {
  AUHT_ROOT = '/auth',
  AUTH_ROOT_NAME = '',
  ROOT_LAYOUT = '/',
  ROOT_LAYOUT_NAME = 'RootLayout',
  BASE_HOME = '/index',
  BASE_HOME_NAME = 'HomeIndex',
  CHATBOT_ROOT = '/chat',
  CHATBOT_ROOT_NAME = 'Chatbot',
  CHATBOT_ASSISTANT_NAME = 'ChatbotAssistant',
  CREATION = '/creation',
  CREATION_NAME = 'creation/index',
  DISCOVER = '/disc/index',
  DISCOVER_NAME = 'DiscoverIndex',
  REDIRECT = '/redirect',
  REDIRECT_NAME = 'Redirect',
  USER_CENTER = '/my/index',
  USER_CENTER_NAME = 'MyIndex',
  WECHAT_AUTHORIZE = '/wx_authorize',
  WECHAT_AUTHORIZE_NAME = 'WechatAuthorize',
}
